import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {
  AuthState,
  CurrentUserConfig,
  CurrentUserType,
} from '../../../interfaces/reducers/auth';

const initialState: AuthState = {
  currentUser: {},
  config: {
    tabs_with_categories: [],
  },
  uniqueId: null,
};

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    login: (state, action: PayloadAction<CurrentUserType | null>) => {
      state.currentUser = action.payload;
    },
    setConfig: (state, action: PayloadAction<CurrentUserConfig>) => {
      state.config = action.payload;
    },
    setUniqueId: (state, action: PayloadAction<string | null>) => {
      state.uniqueId = action.payload;
    },
    logout: state => {
      state.currentUser = null;
    },
  },
});

// Action creators are generated for each case reducer function
export const {login, setConfig, setUniqueId, logout} = authSlice.actions;

export default authSlice.reducer;
